import { Text, View } from '@react-pdf/renderer'
import { FC } from 'react'
import { TableSectionView } from 'src/features/reports/result/components/reportResult/TableSection/parseTableSection'
import { ReportSummaryTableSectionCell } from './ReportSummaryTableSectionCell'
import { tableStyles } from './styles'

type Props = {
  /** 表示する表ビュー。逸脱項目側では逸脱行だけに絞り込んだ view を渡す */
  view: TableSectionView
  /** 表セクション名（見出し） */
  sectionName?: string
}

/**
 * PDF の表セクション。
 * 列 × 行のグリッドを @react-pdf/renderer で描画する。
 * 通常ページでは表全体を、逸脱項目側では逸脱行だけに絞った view を受け取る。
 */
export const ReportSummaryTableSection: FC<Props> = ({ view, sectionName }) => (
  <View style={tableStyles.sectionWrap}>
    {sectionName ? (
      <Text style={tableStyles.sectionName}>{sectionName}</Text>
    ) : null}

    {/* ヘッダー行。ページをまたぐ場合に各ページ先頭で繰り返す */}
    <View style={tableStyles.row} fixed>
      {/* クリップボードからexcelへコピペした際の段組崩れ対策で先頭に空セルを置く */}
      <Text style={tableStyles.headerFirstCell}> </Text>
      {view.headingLabel !== undefined && (
        <Text style={tableStyles.headerRowHeadingCell}>
          {view.headingLabel}
        </Text>
      )}
      {view.columnNodes.map(columnNode => (
        <Text key={columnNode.id} style={tableStyles.headerCell}>
          {columnNode.question?.isRequired === 1 && (
            <Text style={tableStyles.requiredDot}>● </Text>
          )}
          {columnNode.question?.name}
        </Text>
      ))}
    </View>

    {view.rows.map(row => (
      // 行はページ途中で分割しない
      <View key={row.rowNode.id} style={tableStyles.row} wrap={false}>
        {/* 行番号は表全体での通し番号。逸脱フィルタで絞り込んでも全体表示と一致する */}
        <Text style={tableStyles.bodyFirstCell}>{row.rowNumber}</Text>
        {view.headingLabel !== undefined && (
          <Text style={tableStyles.bodyRowHeadingCell}>{row.heading}</Text>
        )}
        {row.cells.map(cell => (
          <ReportSummaryTableSectionCell
            key={cell.questionNode.id}
            cell={cell}
          />
        ))}
      </View>
    ))}
  </View>
)
